import { doc, runTransaction, serverTimestamp } from 'firebase/firestore';
import { db } from '../../shared/storage/firebase';

export async function archiveLibraryCard(id: string, userId: string) {
  await runTransaction(db, async transaction => {
    const ref = doc(db, 'libraryItems', id);
    const snapshot = await transaction.get(ref);
    if (!snapshot.exists()) throw new Error('Card no longer exists');
    if (snapshot.data().status === 'archived') return;
    transaction.update(ref, { status: 'archived', updatedAt: serverTimestamp(), reviewedBy: userId });
  });
}
